import {createElement} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {innerHTMLText} from '@freckle/educator-entities/ts/common/models/html-text'
import type {HeadingProps} from '@freckle/educator-materials/ts/components/typography/heading-props'
import {h4} from './typography.module.scss'

type Props = HeadingProps

export function H4(props: Props) {
  const {children, className, dataTest, id} = props
  const newClassName = addMaybeClassName(h4, className)
  const dataTestObj = dataTest !== null && dataTest !== undefined ? {'data-test': dataTest} : {}
  const TagToUse = props.as ?? 'h4'
  const node = createElement(
    TagToUse,
    {
      className: newClassName,
      ...dataTestObj,
      id,
      ...(props.innerHTMLText !== undefined ? innerHTMLText(props.innerHTMLText) : {}),
    },
    children,
  )
  return node
}
